import { all, put, takeEvery } from 'redux-saga/effects'
import API from '../../../utils/api'
import { errorToaster, successToaster } from '../../../utils/helper'
import { SEND_EMAIL_VERIFICATION_REQUEST, VERIFIED_EMAIL_REQUEST } from '../../actions/actionTypes'
import {
  sendEmailVerificationRequestFailure,
  sendEmailVerificationRequestSuccess,
  verifiedEmailRequestFailure,
  verifiedEmailRequestSuccess,
} from '../../actions/authActions/verifiedEmailAction'

function* verifiedEmailRequestSaga(payload: any): any {
  try {
    const response = yield API.post(`/v1/auth/verify/email`, payload?.payload)
    successToaster(response?.data?.meta?.message)
    yield put(
      verifiedEmailRequestSuccess({
        verifiedEmailData: response?.data,
      })
    )
  } catch (e: any) {
    errorToaster(e?.meta?.message)
    yield put(
      verifiedEmailRequestFailure({
        verifiedEmailError: e?.meta?.message,
      })
    )
  }
}

function* sendEmailVerificationRequestSaga(payload: any): any {
  try {
    const response = yield API.post(`v1/auth/send/email/token`, payload?.payload)
    successToaster(response?.data?.meta?.message)
    yield put(
      sendEmailVerificationRequestSuccess({
        sendEmailVerification: response?.data,
      })
    )
  } catch (e: any) {
    errorToaster(e?.meta?.message)
    yield put(
      sendEmailVerificationRequestFailure({
        sendEmailVerificationError: e?.meta?.message,
      })
    )
  }
}

function* postVerifiedEmailSaga() {
  yield takeEvery(VERIFIED_EMAIL_REQUEST, verifiedEmailRequestSaga)
}

function* postSendVerificationSaga() {
  yield takeEvery(SEND_EMAIL_VERIFICATION_REQUEST, sendEmailVerificationRequestSaga)
}
export default function* verifiedEmailSaga() {
  yield all([postVerifiedEmailSaga(), postSendVerificationSaga()])
}
